/**
 * wx公众号JSSDK鉴权
 */
import { getScanSign } from "@/api/api";
import { isWeixin } from "@/libs/tools";
import { debounce } from "@/libs/tools";

import { Toast } from "vant";
/**
 * 微信公众号鉴权
 */
export const wxAuth = () => {
    //判断当前浏览器环境是否是微信浏览器
    if (isWeixin()) {
        let url = window.location.href.split("#")[0];
        getScanSign({ webUrl: url }).then((res) => {
            wx.config({
                debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                appId: res.data.appId, // 必填，公众号的唯一标识
                timestamp: res.data.timestamp, // 必填，生成签名的时间戳
                nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
                signature: res.data.signature, // 必填，签名
                jsApiList: ["scanQRCode", "openLocation"], // 必填，需要使用的JS接口列表
                openTagList: ["wx-open-launch-weapp"],
            });
        });
    } else {
        return;
    }
};

/**
 * 唤起二维码，添加debounce防抖
 */
export const qrCode = debounce(function () {
    wx.scanQRCode({
        desc: "scanQRCode desc",
        needResult: 0, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ["qrCode"], // 可以指定扫二维码还是一维码，默认二者都有
        success: function (res) {
            let result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
            let stallCode = result.split("?")[1].split("=")[1];
            if (stallCode) {
                Toast(JSON.stringify(res.resultStr));
                window.location.href = res.resultStr;
            } else {
                Toast("请扫描正确的二维码");
            }
        },
    });
}, 200);
